<div class="container">
    <h2> Cost Center: Faculty Ranges</h2>
    <h2>(Indexed by Org Unit)</h2>
    <div class="border border-secondary">
        <table class="table table-hover table-sm mb-0" summary="Table of Cost Center Faculty Ranges" width="100%">
            <tbody>
            <tr class="bg-dark text-white">
                <th valign="top" colspan="2" class="columnheadbig">Org</th>
                <th valign="top" colspan="2" class="columnheadbig">Range</th>
            </tr>
            <tr>
                <th class="columnhead">Unit #</th>
                <th class="columnhead">Name</th>
                <th class="columnhead">From</th>
                <th class="columnhead">To</th>
            </tr>
            <ng-container *ngFor="let ccfacRange of ccfacRanges">
                <tr>
                    <td>{{ccfacRange.orgElementCode}}</td>
                    <td>{{ccfacRange.description}}</td>
                    <td>{{ccfacRange.rangeFrom}}</td>
                    <td>{{ccfacRange.rangeTo}}</td>
                </tr>
            </ng-container>
            </tbody>
        </table>
    </div>
</div>